module.exports = __webpack_public_path__ + "img/img1.667aca69.png";